export const messageDate = (messageDate, isLocal = false) => {
  if (!messageDate) return "";

  const parsedDate = Date.parse(messageDate);
  if (!parsedDate) return "";

  const dateObj = new Date(parsedDate);
  
  // Применяем локальное смещение времени, если указано
  if (isLocal) {
    const offsetInHours = dateObj.getTimezoneOffset() / 60;
    dateObj.setHours(dateObj.getHours() + offsetInHours);
  }

  const now = new Date();
  
  const isDifferentDay =
    dateObj.getFullYear() !== now.getFullYear() ||
    dateObj.getMonth() !== now.getMonth() ||
    dateObj.getDate() !== now.getDate();

  if (isDifferentDay) {
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    return `${day}.${month}`;
  }

  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};
